export default __webpack_public_path__ + "static/media/Icon_MultipleSelectImageChoice.454996bf.svg";